/* eslint-disable no-undef */
export const APP_STORE_IDS = {
  Android: __APP_ANDROID_ID__,
  iOS: __APP_IOS_ID__,
};

export const APP_STORE_URLS = {
  Android: `https://play.google.com/store/apps/details?id=${__APP_ANDROID_ID__}`,
  iOS: `https://apps.apple.com/app/id${__APP_IOS_ID__}`,
};
/* eslint-enable no-undef */

export const DEFAULT_TAB = 'settings';

export const BONUS_TYPES = { CASINO_BONUS: 'casinoBonus', FREE_BETS: 'freeBets', FREE_SPINS: 'freeSpins' };

export const MOBILE_BREAKPOINT = 787;
export const DESKTOP_FIRST_BREAKPOINT = 1024;
export const TABLET_BREAKPOINT = 1200;

export const REPORTS_LINKS = [
  {
    href: '/reports/current/offers',
    label: 'Unmatched',
    value: 'unmatched',
  },
  {
    href: '/reports/current/bets',
    label: 'Matched',
    value: 'matched',
  },
  {
    href: '/reports/settled/bets',
    label: 'Settled',
    value: 'settled',
  },
  {
    href: '/reports/multiples',
    label: 'Multiples',
    value: 'multiples',
  },
  {
    href: '/reports/bet-builder',
    label: 'Bet Builder',
    value: 'betbuilder',
  },
  {
    href: '/reports/transaction-history',
    label: 'Transactions',
    value: 'transaction-history',
  },
  {
    href: '/reports/account-activity',
    label: 'Account Activity',
    value: 'account-activity',
  },
];

export const ZENDESK_WIDGET_TYPES = {
  new: 'new',
  classic: 'classic'
};
